import React, { Component } from 'react';
import logo from './gluonix_imagelogo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" /> 
          <h2> gluonix.io </h2>
        </header>
      </div>
    );
  }
}

export default App;
